function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

// import styles from "./styles.css";
import DiIcon from "../icons/di-icon";
import DiIconArrow from "../icons/di-icon-arrow";
import DiIconCamera from "../icons/di-icon-camera";
import DiIconLive from "../icons/di-icon-live";
import DiViewerMenuBar from "../di-viewer-menu-bar/index";
import { modes, reStyleCategory } from "../../utils";

var DiViewerMenu = function (_Component) {
  _inherits(DiViewerMenu, _Component);

  function DiViewerMenu(props) {
    _classCallCheck(this, DiViewerMenu);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      modelArr: []
    };
    _this.callback = _this.callback.bind(_this);
    return _this;
  }

  DiViewerMenu.prototype.componentDidMount = function componentDidMount() {
    var modelArr = [];
    for (var q = 0; q < 15; q++) {

      // const num = q+1 > 9 ? q+1 : '0'+(q+1);
      // modelArr.push({style: `thumb${q+1}`, url: `/innovation/glamlab/public/images/images/models/ulta_model_${num}_iphone.jpeg`});

      modelArr.push({ style: "thumb" + (q + 1), url: "/innovation/glamlab/public/images/models/" + (q + 1) + ".jpg" });
    }
    this.setState({ modelArr: modelArr });
  };

  DiViewerMenu.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {};

  DiViewerMenu.prototype.callback = function callback(action) {
    this.props.callback(action);
  };

  DiViewerMenu.prototype.setModel = function setModel(imageUrl) {
    this.props.callback({ imageUrl: imageUrl });
  };

  DiViewerMenu.prototype.render = function render() {
    var _this2 = this;

    var safariHack = '';
    // let snapBtnHeight = `${this.props.height * .2}px`;
    var circleBtnHeight = this.props.height * .15 + "px";
    var silhouettePosition = "center " + (this.props.mobile ? '20%' : '32%');
    var display = [modes.menuShowing, modes.takingPhoto, modes.confirmPhoto, modes.noFaceDetected].indexOf(this.props.mode) >= 0 ? 'block' : 'none';
    return React.createElement(
      "div",
      { id: "wrapper",
        style: {
          height: this.props.height + 'px',
          display: display
        } },
      this.props.mode == modes.menuShowing && React.createElement(
        "div",
        { className: "menuBtns" },
        React.createElement(DiViewerMenuBar, {
          mode: this.props.mode,
          cameraDenied: this.props.cameraDenied,
          visibleMode: this.props.visibleMode,
          bottomMenuHeight: this.props.bottomMenuHeight,
          callback: this.callback }),
        !this.props.cameraDenied && React.createElement(
          "div",
          { className: safariHack },
          React.createElement(
            "div",
            { className: "useYourPhoto wrapSection" },
            React.createElement(
              "div",
              { className: "header" },
              "Use Your Photo"
            ),
            React.createElement(
              "div",
              { className: "subheader" },
              "Test a ",
              this.props.selectedCategory === reStyleCategory ? 'hairstyle' : 'makeup look',
              " on yourself!"
            )
          ),
          React.createElement(
            "div",
            { className: "wrapSection btnsWrap" },
            this.props.selectedCategory !== reStyleCategory && React.createElement(DiIcon, {
              className: "btns",
              onClick: function onClick() {
                _this2.callback({ mode: modes.canvasShowing });
              },
              text: 'Live Camera',
              icon: React.createElement(DiIconLive, null) }),
            React.createElement(DiIcon, {
              className: "btns",
              onClick: function onClick() {
                _this2.callback({ mode: modes.takingPhoto });
              },
              text: 'Take Photo',
              icon: React.createElement(DiIconCamera, null) })
          )
        ),
        React.createElement(
          "div",
          { className: safariHack },
          React.createElement(
            "div",
            { className: "useOurPhoto wrapSection " + (this.props.cameraDenied ? 'cameraDenied' : '') },
            React.createElement(
              "div",
              { className: "left header text" },
              "Use Our Photo"
            ),
            React.createElement(
              "div",
              { className: "right subheader text" },
              "Test a ",
              this.props.selectedCategory === reStyleCategory ? 'hairstyle' : 'makeup look',
              " on one of these faces"
            )
          )
        ),
        React.createElement(
          "div",
          { className: safariHack },
          React.createElement(
            "div",
            { className: "wrapSection modelSection" },
            this.state.modelArr.map(function (m) {
              return React.createElement("div", { key: m.style,
                onClick: _this2.setModel.bind(_this2, m.url),
                className: "model " + m.style + " " + (_this2.props.cameraDenied ? 'lessMarg' : '') });
            })
          )
        )
      ),
      this.props.mode == modes.takingPhoto && this.props.selectedCategory === reStyleCategory && this.props.isDesktop && React.createElement("img", { className: 'light-icon', src: "/innovation/glamlab/public/images/" + (this.props.selfieVerificationResult.light ? 'light-green' : 'light-red') + ".svg" }),
      this.props.takePhotoTip && this.props.selectedCategory === reStyleCategory && React.createElement(
        "div",
        { style: {
            position: 'absolute',
            bottom: '55px',
            width: 'calc(100% - 24px)',
            height: '55px',
            background: 'rgba(255,255,255,.75)',
            fontSize: '13px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '13px 12px'
          } },
        this.props.takePhotoTip
      ),
      this.props.mode == modes.takingPhoto && React.createElement(
        "div",
        { className: "silhouette " + (this.props.selectedCategory === reStyleCategory && this.props.isDesktop ? this.props.selfieVerificationResult.silhouette ? 'silhouette-green' : 'silhouette-red' : ''),

          style: { backgroundPosition: silhouettePosition } },
        React.createElement(DiViewerMenuBar, {
          mode: this.props.mode,
          visibleMode: this.props.visibleMode,
          callback: this.callback }),
        React.createElement(
          "div",
          { className: "snapBtn"
            // style={{ height: snapBtnHeight }}
          },
          React.createElement("div", { className: "circle",
            onClick: function onClick() {
              _this2.callback({ snap: Math.random() });
            }
            // style={{ height: circleBtnHeight, width: circleBtnHeight }}
          })
        )
      ),
      [modes.confirmPhoto, modes.noFaceDetected].indexOf(this.props.mode) >= 0 && React.createElement(
        "div",
        { className: "confirmPhoto" },
        React.createElement(DiViewerMenuBar, {
          mode: this.props.mode,
          visibleMode: this.props.visibleMode,
          bottomMenuHeight: this.props.bottomMenuHeight,
          callback: this.callback })
      )
    );
  };

  return DiViewerMenu;
}(Component);

export { DiViewerMenu as default };